import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAds } from '../../../../redux/action/ads/getAds';
import MainLoading from '../../../../utils/MainLoading';
import AboveContactAd from './homepageAds/AboveContactAd';
import ExpoSideAd from './homepageAds/ExpoSideAd';
import FirstAd from './homepageAds/FirstAd';
import SecondAd from './homepageAds/SecondAd';
import CompanyOne from './pagesAds/CompanyOne';
import CompanyTwo from './pagesAds/CompanyTwo';
import SaloonOne from './pagesAds/SaloonOne';
import SaloonTwo from './pagesAds/SaloonTwo';
import './style.scss'

const Ads = () => {
  const [ads, setAds] = useState([])
  const dispatch = useDispatch()
  const all_ads = useSelector(state => state.all_ads)
  const {t} = useTranslation();
  
  useEffect(() => {
    if(!all_ads.all_ads.length) {
      dispatch(fetchAllAds())
    }
  }, [])

  useEffect(() => {
    setAds(all_ads.all_ads)
  }, [all_ads.all_ads])

  const update = () => {
    setTimeout(function(){
      dispatch(fetchAllAds())
    }, 500)
  }

  return (
    <div className='mt-5'>
      {all_ads.loading ?
        <MainLoading />
      :
        <>
          <p>{t("The maximum accepted image size is 2 MB")}</p>
          <p>{t("The_selected_image_format_must_be_one_of_the_following_jpeg_png_jpg_gif_svg")}</p>

          <h6 style={{borderBottom: '1px solid #eee'}} className='mt-5 pb-2'>{t("dashboard_nav_homepage")} : </h6>
          <Row>
            <div className='col-lg-6'><FirstAd data={ads} update={update} /></div>
            <div className='col-lg-6'><SecondAd data={ads} update={update} /></div>
          </Row>
          <Row>
            <div className='col-lg-6'><ExpoSideAd data={ads} update={update} /></div>
            <div className='col-lg-6'><AboveContactAd data={ads} update={update} /></div>
          </Row>

          <h6 style={{borderBottom: '1px solid #eee'}} className='mt-5 pb-2'>{t("dashboard_nav_companies")} : </h6>
          <Row>
            <div className='col-lg-6'><CompanyOne data={ads} update={update} /></div>
            <div className='col-lg-6'><CompanyTwo data={ads} update={update} /></div>
          </Row>
          <h6 style={{borderBottom: '1px solid #eee'}} className='mt-3 pb-2'>{t("dashboard_nav_saloons")} : </h6>
          <Row>
            <div className='col-lg-6'><SaloonOne data={ads} update={update} /></div>
            <div className='col-lg-6'><SaloonTwo data={ads} update={update} /></div>
          </Row>
        </>
      }
    </div>
  )
};

export default Ads;
